import { render, staticRenderFns } from "./LatestMessage.vue?vue&type=template&id=978e5f3e&scoped=true"
import script from "./LatestMessage.vue?vue&type=script&lang=js"
export * from "./LatestMessage.vue?vue&type=script&lang=js"
import style0 from "./LatestMessage.vue?vue&type=style&index=0&id=978e5f3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978e5f3e",
  null
  
)

export default component.exports